module.exports = __webpack_public_path__ + "static/media/arrow_down.5cbece3a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/arrow_down.svg
// module id = 525
// module chunks = 0